// Session-scoped cache for "top attractions [city]" Places API calls.
// Keyed by "cityname|lang" → Promise<Place[]> so concurrent callers
// for the same city share one in-flight request rather than firing duplicates.
const cache = new Map();

export async function fetchTopAttractions(cityName, lang) {
  const key = `${cityName.toLowerCase()}|${lang || 'en'}`;
  if (cache.has(key)) return cache.get(key);

  const promise = fetch(
    `/api/search-attractions?query=${encodeURIComponent('top attractions ' + cityName)}${lang ? `&language=${encodeURIComponent(lang)}` : ''}`
  )
    .then(r => r.json())
    .then(data => (data.results || []).slice(0, 10))
    .catch(() => []);

  cache.set(key, promise);
  return promise;
}
